import React, { useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient'; // Adjust path as needed
import AimdocLoader from '../ui/AimdocLoader';

const OAUTH_FLOW_STORAGE_KEY = 'pendingOAuthFlowParams';

const YOUR_BACKEND_BASE_URL = import.meta.env.VITE_API_URL;

function OAuthCallback() {
  const navigate = useNavigate();
  const hasAttemptedOAuthResume = useRef(false);

  const checkAndResumeZapierOAuthFlow = useCallback(async () => {
    if (hasAttemptedOAuthResume.current) {
      return false;
    }
    const storedOAuthParamsString = localStorage.getItem(OAUTH_FLOW_STORAGE_KEY);
    if (storedOAuthParamsString) {
      try {
        const params = JSON.parse(storedOAuthParamsString);
        localStorage.removeItem(OAUTH_FLOW_STORAGE_KEY);

        if (!params.request_id) {
          return false;
        }
        const query = new URLSearchParams();
        query.set('request_id', params.request_id);
        query.set('frontend_authenticated', 'true');

        const resumeUrlPath = `/oauth/authorize?${query.toString()}`;
        const fullResumeUrl = `${YOUR_BACKEND_BASE_URL}${resumeUrlPath}`;

        hasAttemptedOAuthResume.current = true;
        window.location.href = fullResumeUrl;
        return true;
      } catch (e) {
        localStorage.removeItem(OAUTH_FLOW_STORAGE_KEY);
      }
    }
    return false;
  }, []);

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        const didResumeZapierFlow = await checkAndResumeZapierOAuthFlow();
        if (!didResumeZapierFlow) {
          navigate('/');
        }
      } else if (event === 'SIGNED_OUT') {
         navigate('/login');
      }
    });

    return () => {
      if (authListener?.subscription) {
        authListener.subscription.unsubscribe();
      }
    };
  }, [navigate, checkAndResumeZapierOAuthFlow]);

  return <AimdocLoader label="Connecting your account" />;
}

export default OAuthCallback; 